import axios from "axios";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import moment from "moment";
import { CircleLoader } from "react-spinners";

const RepEdit = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [blacklist, setBlacklist] = useState([]);
    const [search, setSearch] = useState('');
    const [searchFilter, setFilter] = useState('company')

    const [representatives, setRepresentatives] = useState()

    const user_id = Cookies.get('token_id')

    const test_link = "http://localhost:3000/"
    const production_link = "https://apple-tree-server.vercel.app/"

    const admin = Cookies.get('token_admin');



    // const getRepresentatives = async () => {
    //     await axios.get(production_link +'representatives/')
    //     .then(response => {
    //         setRepresentatives(response.data)
    //     })

    // }

    const getRepresentatives = async () => {
        // axios.defaults.headers.post['Content-Type'] ='application/x-www-form-urlencoded';
        
        if (admin == 'yes') {
            await axios.get(production_link + "all/representative")
            .then( response => {
                let rep_data = response.data.filter((data) => {
                    if (searchFilter === 'company') {
                        return data.company_name.toLowerCase().includes(search)
                    }  else if (searchFilter === 'representative') {
                        
                                if ((data.first_name + ' ' + data.last_name).toLowerCase().includes(search)) {
                                    return true
                                } 
                            
                    
                    } 
            })
                console.log(response)
                setRepresentatives(rep_data)
            })
        } else {
            await axios.post(production_link + "current/representative", {
            user_id
        })
        .then( response => {
            let rep_data = response.data.filter((data) => {
                if (searchFilter === 'company') {
                    return data.company_name.toLowerCase().includes(search)
                }  else if (searchFilter === 'representative') {
                    
                            if ((data.first_name + ' ' + data.last_name).toLowerCase().includes(search)) {
                                return true
                            } 
                        
                
                } 
        })
            console.log(response)
            setRepresentatives(rep_data)
        })
        }
        
        
    }

    useEffect(() => {
        setIsVisible(true);
        getRepresentatives();
    }, []);

    useEffect(() => {
        getRepresentatives()
    }, [search, searchFilter]);

    const navigate = useNavigate();

    if (representatives == null) {
        return (
            <div>
            <h4 className="text-center display-5 fst-italic text-muted">Edit Representatives</h4>
                 
                <div style={{height:"50vh"}} className="d-flex justify-content-center align-items-center ">
                
                            <CircleLoader size={200} color="#cdc59a"/>
            </div>
            </div>
            
        )
    }

    return ( 
        <div>
            <h4 className="text-center display-5 fst-italic text-muted">Edit Representatives</h4>
            <div >
                    <p className="text-success text-center fs-6 fst-italic lead d-block">admin mode</p>

                    </div>
           
                <div className="d-flex justify-content-center m-4">
                    

                <div className="btn-group w-75">
                    <select name="filter" id="" className="form-select w-25 rounded-0 rounded-start" onChange={(e) => {
                        setFilter(e.target.value)
                        }}>
                            <option value="company">Company</option>
                            <option value="representative">Representative</option>
      
                    </select>
                    <input type="text" className="form-control w-75 rounded-0 rounded-end" placeholder={`Search by ${searchFilter}`} onChange={(e) => {
                        setSearch(e.target.value.toLowerCase());
                    }}></input>
                </div>
                
                
            </div>
            <div className="container w-75">
                    <p className="text-muted text-end blockquote-footer">{representatives.length} results</p>
                </div>
            
            {
                representatives.map((item) => {
                    let blacklist_date = item.blacklist_date;
                    const new_date = moment(blacklist_date).format('Do MMM YYYY')
                    return (
                        <div className={`container notification w-75 py-3 my-3 ${isVisible ? 'fade-in-left' : ''}`} onClick={() => {
                            navigate(`/edit/representatives/${item.id}$${item.ref}`)
                        }}>
                            <p className="blacklist-text fst-italic fs-6 ms-3 mt-2 mb-0">Company name:  {item.company_name}</p>
                            <p className="blacklist-text fst-italic fs-6 ms-3 mt-0 mb-0">Representative:  {item.first_name} {item.last_name}</p>
                            {/* <p className="blacklist-text fst-italic fs-6 ms-3 mt-0 mb-0">Listed by: {item.user_company} ({item.user_first_name} {item.user_last_name} )</p>
                            <p className="blacklist-text fst-italic fs-6 ms-3 mt-0 mb-0">Listing date: {new_date}</p> */}
                        </div>
                )})
            }
        </div>
        
        
     );
}
 
export default RepEdit;